import { render } from "./Prestador_EspePres.vue?vue&type=template&id=44fae360"
import script from "./Prestador_EspePres.vue?vue&type=script&lang=js"
export * from "./Prestador_EspePres.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__